import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
import _camelCase from "lodash/camelCase";
import _upperFirst from "lodash/upperFirst";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useRef, useState } from 'react';
import Collapsible from 'react-collapsible';
import classnames from 'classnames';
import { Breakpoint } from "../Responsive/Breakpoint/Breakpoint";
import { Button } from "../Button/Button/Button";
import { Link } from "../Button/Link/Link";
import { ToggleButton } from "../Button/ToggleButton/ToggleButton";
import { Text } from "../Text/Text/Text";
import Utility from "../Utility/Utility";
import styles from "./CollapsiblePanel.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CollapsiblePanel = function CollapsiblePanel(_ref) {
  var children = _ref.children,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$activeTrail = _ref.activeTrail,
    activeTrail = _ref$activeTrail === void 0 ? false : _ref$activeTrail,
    _ref$collapsed = _ref.collapsed,
    initCollapsed = _ref$collapsed === void 0 ? false : _ref$collapsed,
    _ref$collapsible = _ref.collapsible,
    initCollapsible = _ref$collapsible === void 0 ? false : _ref$collapsible,
    _ref$collapsibleBreak = _ref.collapsibleBreakpoint,
    collapsibleBreakpoint = _ref$collapsibleBreak === void 0 ? false : _ref$collapsibleBreak,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$contentOuterClas = _ref.contentOuterClassName,
    contentOuterClassName = _ref$contentOuterClas === void 0 ? '' : _ref$contentOuterClas,
    _ref$linkWrapperClass = _ref.linkWrapperClassName,
    linkWrapperClassName = _ref$linkWrapperClass === void 0 ? '' : _ref$linkWrapperClass,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? 'right' : _ref$iconPosition,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? '' : _ref$iconColor,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? '20px' : _ref$iconSize,
    _ref$buttonAttributes = _ref.buttonAttributes,
    buttonAttributes = _ref$buttonAttributes === void 0 ? {} : _ref$buttonAttributes,
    _ref$buttonClassName = _ref.buttonClassName,
    buttonClassName = _ref$buttonClassName === void 0 ? '' : _ref$buttonClassName,
    buttonText = _ref.buttonText,
    buttonUrl = _ref.buttonUrl,
    _ref$buttonNewWindow = _ref.buttonNewWindow,
    buttonNewWindow = _ref$buttonNewWindow === void 0 ? false : _ref$buttonNewWindow,
    _ref$buttonStyle = _ref.buttonStyle,
    buttonStyle = _ref$buttonStyle === void 0 ? 'default' : _ref$buttonStyle,
    _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? {
      close: 'Click to close',
      open: 'Click to open'
    } : _ref$labels,
    _ref$flexEndToggleBut = _ref.flexEndToggleButton,
    flexEndToggleButton = _ref$flexEndToggleBut === void 0 ? false : _ref$flexEndToggleBut,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  var _useState = useState(!initCollapsed),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(initCollapsible),
    _useState4 = _slicedToArray(_useState3, 2),
    collapsible = _useState4[0],
    setCollapsible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    inTransition = _useState6[0],
    setInTransition = _useState6[1];
  var uuid = useRef(Utility.generateUID(''));
  useEffect(function () {
    setOpen(!initCollapsed);
    setCollapsible(initCollapsible);
  }, [initCollapsible, initCollapsed]);
  var onPress = function onPress() {
    setOpen(function (isOpen) {
      return !isOpen;
    });
  };
  var onOpenCollapsible = function onOpenCollapsible() {
    // Once opening has finished.
    setInTransition(false);
  };
  var onCloseCollapsible = function onCloseCollapsible() {
    // Once closing has finished.
    setInTransition(false);
  };
  var onOpeningCollapsible = function onOpeningCollapsible() {
    // Once opening has started.
    setInTransition(true);
  };
  var onClosingCollapsible = function onClosingCollapsible() {
    // Once closing has started.
    setInTransition(false);
  };
  var renderCollapsibleButton = function renderCollapsibleButton() {
    var styleTypeClass = _upperFirst(_camelCase(buttonStyle));
    var childStyles = buttonStyle === 'default' ? '' : styles["link".concat(styleTypeClass)];
    return /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.linkWrapper, linkWrapperClassName),
      children: [/*#__PURE__*/_jsx(ToggleButton, _objectSpread(_objectSpread({
        accessibilityLabel: open ? labels.close : labels.open,
        fullwidth: true,
        iconPosition: iconPosition,
        iconColor: iconColor,
        iconSize: iconSize,
        selected: open,
        onPress: onPress,
        "aria-expanded": collapsible && open,
        "aria-haspopup": collapsible,
        styleType: buttonStyle,
        childStyles: childStyles,
        flexEnd: flexEndToggleButton && iconPosition !== 'left',
        variant: variant,
        inTransition: inTransition,
        className: buttonClassName
      }, buttonAttributes), {}, {
        children: !buttonUrl && /*#__PURE__*/_jsx("span", {
          className: classnames(styles.buttonText, className),
          children: buttonText
        })
      })), buttonUrl && /*#__PURE__*/_jsx(Button, {
        url: buttonUrl,
        newWindow: buttonNewWindow,
        className: classnames(styles.link, active && styles.linkActive, activeTrail && styles.linkActiveTrail, childStyles),
        type: "banner-trigger",
        stopPropagation: true,
        attributes: buttonAttributes,
        children: /*#__PURE__*/_jsx("span", {
          className: styles.linkInner,
          children: buttonText
        })
      })]
    });
  };
  var renderNonCollapsibleButton = function renderNonCollapsibleButton() {
    var text = /*#__PURE__*/_jsx(Text, {
      className: classnames(styles.text, className),
      typog: "bodycopySmall",
      children: buttonText
    });
    return !buttonUrl ? text : /*#__PURE__*/_jsx(Link, {
      url: buttonUrl,
      newWindow: buttonNewWindow,
      attributes: buttonAttributes,
      children: text
    });
  };
  var renderButton = function renderButton() {
    return !collapsibleBreakpoint ? collapsible ? renderCollapsibleButton() : renderNonCollapsibleButton() : /*#__PURE__*/_jsxs(Breakpoint, {
      breakpoint: collapsibleBreakpoint || 'small',
      children: [collapsible ? renderCollapsibleButton() : renderNonCollapsibleButton(), renderNonCollapsibleButton()]
    });
  };
  var renderPanel = function renderPanel(isCollapsible, isOpen) {
    var variantClass = _capitalize(variant);
    var addVariant = variant !== 'default';
    return /*#__PURE__*/_jsx(Collapsible, {
      contentElementId: 'collapsible-content-' + uuid.current,
      className: styles.container,
      openedClassName: classnames(styles.container, {
        [styles["opened".concat(variantClass)]]: addVariant
      }),
      contentOuterClassName: classnames(styles.outer, contentOuterClassName),
      triggerClassName: styles.trigger,
      triggerOpenedClassName: styles.trigger,
      easing: 'ease',
      open: isOpen,
      transitionTime: 350,
      trigger: renderButton(),
      triggerDisabled: !isCollapsible || !!buttonUrl,
      onOpen: onOpenCollapsible,
      onClose: onCloseCollapsible,
      onOpening: onOpeningCollapsible,
      onClosing: onClosingCollapsible,
      triggerElementProps: {
        role: 'group',
        id: 'collapsible-trigger-' + uuid.current
      },
      children: /*#__PURE__*/_jsx("div", {
        "aria-hidden": isCollapsible && !isOpen,
        className: isCollapsible && !isOpen ? styles.collapsed : undefined,
        children: children
      })
    });
  };
  return !collapsibleBreakpoint ? renderPanel(collapsible, open) : /*#__PURE__*/_jsxs(Breakpoint, {
    breakpoint: collapsibleBreakpoint || 'small',
    children: [renderPanel(collapsible, open), renderPanel(false, true)]
  });
};